import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {DELETE, GET, POST, PUT} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseFbResourceAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _requestLoginAccount = (accountId, device = '') => {
    return api.makeAuthRequest({
        method: POST,
        url: `/accounts/${accountId}/login`,
        data: {
            device
        }
    })
}

export const _getListWorker = (page = 1, limit, status) => {
    return api.makeAuthRequest({
        method: GET,
        url: '/accounts',
        params: {
            page,
            limit,
            status
        },
    })
}

export const _activeAccount = (id) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/accounts/${id}/activate`,

    })
}

export const _createNewWorker = ({username, password, note, cookies}) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/accounts',
        data: {
            username, password, note, cookies
        },
    })
}

export const _updateWorkerData = (workerId, updateData) => {
    return api.makeAuthRequest({
        method: PUT,
        url: `/accounts/${workerId}`,
        data: {
            ...updateData
        },
    })
}

export const _deleteWorker = (id) => {
    return api.makeAuthRequest({
        method: DELETE,
        url: `/accounts/${id}`,

    })
}

export const _getWorkerStatistics = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/accounts/statistics`,
    })
}

export const _getIAASpeed = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/iaa/speed`,
    })
}

export const _getIAAAvailableAccounts = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/iaa/available-accounts`,
    })
}

export const _getIAAMinimumAccounts = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/iaa/minimum-accounts`,
    })
}

export const _getTotalProcesses = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/iaa/total-processes`,
    })
}

export const _getTotalQueuedJobs = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/iaa/total-jobs`,
    })
}



// WEBPACK FOOTER //
// ./src/services/apis/WorkerServices.js